import { z } from "zod";
import { ZDateish, ZObjectIdString } from "./foundationSchema";
export const ZAuthProvider = z.enum(["MICROSOFT", "LOCAL"]);
export const INTERNAL_EMAIL_DOMAINS = ["multiconsult.no", "linkarkitektur.no"];
export const emailIsInternal = (email) => {
    const domain = email.split("@")[1].toLowerCase();
    return INTERNAL_EMAIL_DOMAINS.includes(domain);
};
export const ZUserLocalAuth = z.object({
    username: z.string(), // unique
    passwordHash: z.string(), // argon2/bcrypt etc – aldrig plain
    passwordUpdatedAt: ZDateish.optional().nullable(),
});
export const ZUser = z.object({
    _id: ZObjectIdString, // Mongo
    authProvider: ZAuthProvider,
    msTid: z.string().optional(),
    msOid: z.string().optional(), // required i koden när authProvider === "MICROSOFT"
    email: z.string().email().toLowerCase(),
    displayName: z.string(),
    givenName: z.string().optional(),
    surname: z.string().optional(),
    initials: z.string().max(4).optional(),
    createdAt: ZDateish,
    lastLoginAt: ZDateish.optional().nullable(),
    roles: z.array(z.string()).optional(), // "admin", "validator", ...
    isActive: z.boolean().optional(),
    localAuth: ZUserLocalAuth.optional(),
    msUpn: z.string().optional(), // Fallback UPN från Graph när email saknas i token
    isExternal: z.boolean().optional(),
});
export const ZUserRef = z.object({
    _id: ZObjectIdString, // users._id (MongoId)
    name: z.string(), // snapshot av displayName
});
export const ZPublicUser = z.object({
    _id: z.string(), // vår interna user-id (Mongo ObjectId som string)
    displayName: z.string(),
    email: z.string().email().optional(),
    isExternal: z.boolean().optional(),
});
const toUserRef = (user) => ({
    _id: user._id,
    name: user.displayName,
});
